// fake-declare buffer so we can use it in the code that compiles for the browser (if won't be used there)
declare type Buffer = any;
declare var Buffer: any;

declare const window: any; // needed so that the below works in Node.js

// need these because our ancient TypeScript (2.8) doesn't have TextEncoder/TextDecoder
declare class TextEncoder {
  encode(input?: string): Uint8Array;
}

declare class TextDecoder {
  decode(input?: Uint8Array): string;
}

// Universal Base64 encoding function
export function base64UrlEncode(input: string): string {
  let base64String: string;

  // Ensure the string is encoded as UTF-8
  const utf8Encoder = new TextEncoder();
  const utf8Bytes = utf8Encoder.encode(input);

  // Browser environment
  if (typeof window !== 'undefined' && typeof window.btoa === 'function') {
    base64String = window.btoa(String.fromCharCode.apply(null, utf8Bytes));
  } else {
    // Node.js environment
    base64String = Buffer.from(utf8Bytes).toString('base64');
  }

  // Convert to URL-safe Base64
  return base64String
    .replace(/\+/g, '-') // Replace + with -
    .replace(/\//g, '_') // Replace / with _
    .replace(/=+$/, ''); // Remove trailing =
}

// Universal Base64 decoding function
export function base64UrlDecode(input: string): string {
  if (input === undefined) {
    return undefined;
  }
  // Convert from URL-safe Base64 to standard Base64
  let base64String = input
    .replace(/-/g, '+') // Replace - with +
    .replace(/_/g, '/'); // Replace _ with /

  // Manually pad with '=' to make the length a multiple of 4
  while (base64String.length % 4 !== 0) {
    base64String += '=';
  }

  // Browser environment
  if (typeof window !== 'undefined' && typeof window.atob === 'function') {

    // decode base64 to binary string
    const binaryString = window.atob(base64String);

    // convert binary string to a Uint8Array (UTF-8 bytes)
    const utf8Bytes = new Uint8Array([...binaryString].map(c => c.charCodeAt(0)));

    // decode UTF-8 bytes into a Unicode string
    return new TextDecoder().decode(utf8Bytes);
    // Node.js environment
  } else {
    return Buffer.from(base64String, 'base64').toString('utf-8');
  }
}

// Encode an object to a Base64 URL-safe string - empty object is encoded as empty string
export function base64UrlEncodeObject(obj: any): string {
  if (typeof obj !== 'object' || Object.keys(obj).length === 0) {
    return '';
  }
  try {
    const jsonString = JSON.stringify(obj);
    return base64UrlEncode(jsonString);
  } catch (e) {
    console.error('Error encoding object to Base64 URL-safe string:', e);
    return '';
  }
}

// Decode a Base64 URL-safe string back to an object - empty string is decoded as empty object
export function base64UrlDecodeObject<T>(encoded: string): T {
  if (encoded === '' || encoded === undefined) {
    return {} as T;
  }
  try {
    const jsonString = base64UrlDecode(encoded);
    return JSON.parse(jsonString) as T;
  } catch (e) {
    console.error('Error decoding object from Base64 URL-safe string:', e);
    return {} as T;
  }
}
